import { classNames } from "../utils/clsx";

export function SmallSpin() {
  return (
    <svg
      className="animate-spin -ml-1 mr-3 h-5 w-5 text-black"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
}

export function Spinner(props: {
  size?: number;
  color?: string;
  className?: string;
}) {
  const size = props.size ?? 50;
  return (
    <div
      className={classNames(
        "animate-spin inline-block border-8 border-solid",
        props.className
      )}
      style={{
        width: size,
        height: size,
        borderTopColor: props.color ?? "black",
        borderRadius: "50%",
      }}
    />
  );
}
